import React from "react";
import LogsSection from "../../Sections/Logs/index";
import Dashboard from "../Dashboard/Dashboard";

const LogsComponent = () => {
    return (
        <Dashboard sectionName={<LogsSection />}/>
    );
};

export default LogsComponent;
